// A generic function to force TypeScript to fail when it is able to reach this function.
export const exhaustiveCheck = (x) => {
    console.warn('Exhaustive check caught following value:', x);
};
